import { useEffect, useState } from "react";
import Item from "../item/item";
import "./list.css";
import { type } from "@testing-library/user-event/dist/type";

function List({
  itemsList,
  deleteFun,
  handleCheck,
  status,
  updateFun,

  dispatch,
}) {
  console.log(itemsList);
  let [sorted, setSorted] = useState("input");
  function askToClear() {
    dispatch({ type: "show", payload: true });
  }

  let sortedItem;
  if (sorted === "input") {
    sortedItem = itemsList;
  }

  if (sorted === "description") {
    sortedItem = itemsList.slice().sort((a, b) => {
      return a.oneTask.localeCompare(b.oneTask);
    });
  }

  if (sorted === "status") {
    sortedItem = itemsList
      .slice()
      .filter((item) => item.status == status)
      .sort((a, b) => {
        return a.oneTask.localeCompare(b.oneTask);
      });
  }

  // console.log(so);
  return (
    <div className="list">
      <ul>
        {sortedItem?.map((ele, i) => {
          return (
            <Item
              itemsList={itemsList}
              item={ele}
              deleteFun={deleteFun}
              handleCheck={handleCheck}
              updateFun={updateFun}
              dispatch={dispatch}
              key={i}
            />
          );
        })}
      </ul>

      <div className="actions">
        <select
          name=""
          id=""
          value={sorted}
          onChange={(e) => setSorted(e.target.value)}
        >
          <option value="input">sort by input order</option>
          <option value="description">sort by descriptionr</option>
          <option value="status">sort by status</option>
        </select>
        <button onClick={askToClear}>clear list</button>
      </div>
    </div>
  );
}

export default List;
